import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useFadeIn } from "../App";
import SafeVideo from "../components/SafeVideo";
import ShapeDivider from "../components/ShapeDivider";
import { getImageById } from "../data/wildlifeGallery";

const CareMap = () => {
  const [heroRef, heroVisible] = useFadeIn();
  const [mapRef, mapVisible] = useFadeIn();
  const [statsRef, statsVisible] = useFadeIn();
  const [videosRef, videosVisible] = useFadeIn();
  const [ctaRef, ctaVisible] = useFadeIn();

  return (
    <>
      {/* Hero Section */}
      <section
        ref={heroRef}
        className={`hero-caremap-section fade-in-section ${heroVisible ? "is-visible" : ""}`}
        style={{
          backgroundImage: `linear-gradient(rgba(74, 92, 45, 0.8), rgba(141, 191, 75, 0.8)), url(${getImageById('pelican-close').url})`,
          padding: "120px 0 80px",
          color: "white",
          position: "relative",
          overflow: "hidden",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed"
        }}
      >
        <div
          className="hero-pattern"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage:
              'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Cpath d="M30 15l15 15-15 15-15-15z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            opacity: 0.4,
          }}
        ></div>
        <Container className="position-relative">
          <Row className="justify-content-center text-center">
            <Col lg={10}>
              <div
                className="hero-icon mb-4"
                style={{
                  width: "100px",
                  height: "100px",
                  background: "rgba(255, 255, 255, 0.15)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto",
                  fontSize: "3rem",
                  backdropFilter: "blur(10px)",
                  border: "2px solid rgba(255, 255, 255, 0.2)",
                }}
              >
                <i className="fas fa-map-marked-alt"></i>
              </div>
              <h1 className="display-3 fw-bold mb-4" style={{ color: "white" }}>
                Care Map
              </h1>
              <p
                className="lead mb-5"
                style={{ fontSize: "1.3rem", opacity: 0.95 }}
              >
                Discover the locations where we've successfully helped and
                released wildlife across Queensland
              </p>
              <div className="hero-stats d-flex justify-content-center gap-5 flex-wrap">
                <div className="stat-item text-center">
                  <h3
                    className="fw-bold mb-1"
                    style={{ color: "var(--primary-yellow)" }}
                  >
                    10,000+
                  </h3>
                  <p className="mb-0" style={{ opacity: 0.9 }}>
                    animals rehabilitated
                  </p>
                </div>
                <div className="stat-item text-center">
                  <h3
                    className="fw-bold mb-1"
                    style={{ color: "var(--primary-yellow)" }}
                  >
                    300+
                  </h3>
                  <p className="mb-0" style={{ opacity: 0.9 }}>
                    Rescues
                  </p>
                </div>
                <div className="stat-item text-center">
                  <h3
                    className="fw-bold mb-1"
                    style={{ color: "var(--primary-yellow)" }}
                  >
                    50+
                  </h3>
                  <p className="mb-0" style={{ opacity: 0.9 }}>
                    Release Sites
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <ShapeDivider color="white" />
      </section>

      {/* Map Section */}
      <section
        ref={mapRef}
        className={`map-section fade-in-section ${mapVisible ? "is-visible" : ""}`}
        style={{ padding: "100px 0" }}
      >
        <Container>
          <Row className="justify-content-center text-center mb-5">
            <Col lg={10}>
              <h2
                className="mb-4"
                style={{ color: "var(--primary-green)", fontSize: "2.5rem" }}
              >
                Interactive Care Map
              </h2>
              <p
                className="lead mb-4"
                style={{ fontSize: "1.2rem", lineHeight: "1.8" }}
              >
                Explore the locations across Queensland where our dedicated team
                has rescued, rehabilitated, and successfully released wildlife
                back into their natural habitats.
              </p>
              <p
                style={{
                  fontSize: "1.1rem",
                  lineHeight: "1.7",
                  color: "var(--dark-text)",
                }}
              >
                Each marker represents a success story - a life saved and
                returned to the wild where it belongs.
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={12}>
              <Card
                className="map-container border-0 shadow-lg"
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(249,247,242,0.98) 100%)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  minHeight: "600px",
                }}
              >
                <Card.Header
                  className="border-0 text-center py-4"
                  style={{
                    background:
                      "linear-gradient(135deg, var(--primary-yellow) 0%, #e6b73e 100%)",
                    color: "white",
                  }}
                >
                  <h5 className="mb-0 fw-bold">
                    <i className="fas fa-map-marker-alt me-2"></i>
                    Care Map of Injured Animals in Queensland
                  </h5>
                </Card.Header>
                <Card.Body className="p-0" style={{ height: "600px" }}>
                  <iframe
                    className="care-map-iframe"
                    title="Care map of injured animals in Queensland"
                    name="htmlComp-iframe"
                    width="100%"
                    height="100%"
                    src="https://www.google.com/maps/d/u/0/embed?mid=1ZCo8Eh9GeGOVdoi9UbTY52u_joLx021V&ehbc=2E312&ll=-27.73266109872857%2C153.04524219999996&z=8"
                    style={{
                      border: "none",
                      borderRadius: "0 0 20px 20px",
                    }}
                    loading="lazy"
                  ></iframe>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Impact Statistics */}
      <section
        ref={statsRef}
        className={`impact-stats-section section-bg fade-in-section ${statsVisible ? "is-visible" : ""}`}
        style={{ padding: "80px 0" }}
      >
        <Container>
          <Row className="text-center mb-5">
            <Col lg={8} className="mx-auto">
              <h2
                className="mb-4"
                style={{ color: "var(--primary-green)", fontSize: "2.5rem" }}
              >
                Our Conservation Impact
              </h2>
              <p
                className="lead"
                style={{ fontSize: "1.2rem", color: "var(--dark-text)" }}
              >
                Every marker on our map represents hope, dedication, and
                successful wildlife conservation in action
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {[
              {
                icon: "fa-dove",
                number: "10,000+",
                label: "Animals Rehabilitated",
                description:
                  "From tiny finches to large raptors, each bird receives specialised care",
              },
              {
                icon: "fa-paw",
                number: "120+",
                label: "Mammals Rescued",
                description:
                  "Kangaroos, possums, and other native mammals returned to the wild",
              },
              {
                icon: "fa-seedling",
                number: "25+",
                label: "Habitat Sites",
                description:
                  "Protected release locations ensuring long-term wildlife success",
              },
              {
                icon: "fa-heart",
                number: "98%",
                label: "Recovery Rate",
                description:
                  "High success rate through our ethical and sustainable care model",
              },
            ].map((stat, index) => (
              <Col md={6} lg={3} key={index}>
                <Card
                  className="impact-card h-100 border-0 shadow-lg text-center"
                  style={{
                    borderRadius: "20px",
                    padding: "2rem 1rem",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    background: "white",
                  }}
                >
                  <Card.Body>
                    <div
                      className="impact-icon mb-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        background:
                          "linear-gradient(135deg, var(--primary-green) 0%, var(--accent-green) 100%)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        color: "white",
                        fontSize: "2rem",
                        boxShadow: "0 10px 30px rgba(74, 92, 45, 0.3)",
                      }}
                    >
                      <i className={`fas ${stat.icon}`}></i>
                    </div>
                    <h3
                      className="fw-bold mb-2"
                      style={{
                        color: "var(--primary-yellow)",
                        fontSize: "2.5rem",
                      }}
                    >
                      {stat.number}
                    </h3>
                    <h5
                      className="fw-bold mb-3"
                      style={{ color: "var(--primary-green)" }}
                    >
                      {stat.label}
                    </h5>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
                    >
                      {stat.description}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Conservation Success Stories Videos */}
      <section
        ref={videosRef}
        className={`success-videos-section fade-in-section ${videosVisible ? "is-visible" : ""}`}
        style={{ padding: "100px 0", background: "white" }}
      >
        <Container>
          <Row className="text-center mb-5">
            <Col lg={8} className="mx-auto">
              <h2
                className="mb-4"
                style={{ color: "var(--primary-green)", fontSize: "2.5rem" }}
              >
                Conservation Success Stories
              </h2>
              <p
                className="lead"
                style={{ fontSize: "1.2rem", color: "var(--dark-text)" }}
              >
                Witness the incredible moments that make our conservation work so rewarding -
                from rescue to release, these are the victories that drive us forward
              </p>
            </Col>
          </Row>
          <Row className="g-5 justify-content-center">
            {[
              "https://cdn.builder.io/o/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fe2397ac2ae9f4c44a9c8045371f8a781?alt=media&token=7a28f07b-8735-4a44-9e12-cbd2de8ba397&apiKey=35ffb80beae24a4483ace4ab1c92b206",
              "https://cdn.builder.io/o/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fe9191a88174848ddbf90fc658dd12ced?alt=media&token=f101eff4-3a00-418c-9cd1-1863927c049d&apiKey=35ffb80beae24a4483ace4ab1c92b206",
              "https://cdn.builder.io/o/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F1be274ae35624bdfad0de4a971543d83?alt=media&token=51dae5bf-01c5-4f30-8d69-6cf9857b056d&apiKey=35ffb80beae24a4483ace4ab1c92b206"
            ].map((videoUrl, index) => (
              <Col lg={4} key={index}>
                <div
                  className="video-container shadow-lg"
                  style={{
                    borderRadius: "25px",
                    overflow: "hidden",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                >
                  <SafeVideo
                    src={videoUrl}
                    controls
                    className="w-100"
                    style={{ aspectRatio: "16/9", objectFit: "cover" }}
                    preload="metadata"
                    autoGeneratePoster={true}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Call to Action */}
      <section
        ref={ctaRef}
        className={`cta-caremap-section wildlife-bg-section fade-in-section ${ctaVisible ? "is-visible" : ""}`}
        style={{
          backgroundImage: `linear-gradient(rgba(74, 92, 45, 0.85), rgba(141, 191, 75, 0.85)), url(${getImageById('frogmouth-amazing').url})`,
          padding: "80px 0",
          color: "white",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed"
        }}
      >
        <Container className="text-center">
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2
                className="mb-4"
                style={{ color: "white", fontSize: "2.5rem" }}
              >
                Be Part of Our Story
              </h2>
              <p
                className="lead mb-4"
                style={{ fontSize: "1.2rem", opacity: 0.9 }}
              >
                Every animal we help becomes part of this map. Your support
                helps us add more success stories and expand our conservation
                efforts across Queensland.
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <a
                  href="https://www.paypal.com/donate/?hosted_button_id=JWCTWZHY89WV2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-light btn-lg px-4"
                  style={{
                    borderRadius: "50px",
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                >
                  <i className="fas fa-heart me-2"></i>
                  Support Our Mission
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CareMap;
